var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pastBox"},[_c('div',{ref:"dEcharts",attrs:{"id":"dEcharts"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }